<template>
  <b-container>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <h1>{{ $t("system.module.menu") }}</h1>

    <b-row class="mb-3 ml-0">
      <b-col>
        <router-link :to="getUrlBackToList">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
      </b-col>
    </b-row>
    <!-- {{newModel}} -->
    <!-- {{model}} -->
    <b-row>
      <b-col sm="3">
        <module-menu-bi-modal
          :newField.sync="newModel"
          :moduleId="id"
          :options="biOptions"
        >
        </module-menu-bi-modal>
      </b-col>
      <b-col class="biModal" v-if="type != 2">
        <module-menu-form-modal
          :newField.sync="newModel"
          :moduleId="id"
          :options="formOptions"
        >
        </module-menu-form-modal>
      </b-col>
    </b-row>

    <b-table-simple hover small caption-top responsive>
      <b-thead>
        <b-tr>
          <b-th v-for="field in fields" :key="field.key">
            {{ field.label }}
          </b-th>
        </b-tr>
      </b-thead>
      <template v-for="row in fieldsList">
        <!-- {{row}} -->
        <b-tr :key="row.item.sequenceNumber">
          <b-td>
            <b-button
              class="ml-2"
              variant="danger"
              size="sm"
              @click="deleteField(row)"
            >
              X
            </b-button>
            <table-menu-resequence
              class="d-inline ml-2"
              :item="row.item"
              :items="model"
              :display-name="row.item.sequenceNumber"
            ></table-menu-resequence>
          </b-td>
          <b-td>
            {{ row.item.sequenceNumber }}
          </b-td>
          <b-td>
            {{ row.item.formId }}
          </b-td>
          <b-td>
            {{ row.item.formName }}
          </b-td>
          <b-td>
            {{ row.item.powerBiViewId }}
          </b-td>
          <b-td>
            {{ row.item.biName }}
          </b-td>
        </b-tr>
      </template>
    </b-table-simple>
    <b-row>
      <b-col>
        <b-button type="submit" @click="save">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- <div>{{newModel}}</div> -->
  </b-container>
</template>
<script>
import MenuSequenceControl from "@/components_rms/System/Module/MenuSequenceControl";
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    ModuleMenuFormModal: () =>
      import("@/components_rms/System/Module/ModuleMenuFormModal.vue"),
    ModuleMenuBiModal: () =>
      import("@/components_rms/System/Module/ModuleMenuBiModal.vue"),
    TableMenuResequence: () =>
      import("@/components_rms/System/Module/TableMenuResequence.vue"),
  },
  mixins: [MenuSequenceControl],
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          label: this.$t("system.module.sequenceNumber"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "formId",
          filterKey: "formId",
          label: this.$t("system.module.formId"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "formName",
          filterKey: "formName",
          label: this.$t("system.module.formName"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "powerBiViewId",
          filterKey: "powerBiViewId",
          label: this.$t("system.module.powerBiViewId"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "biName",
          filterKey: "biName",
          label: this.$t("system.module.biName"),
          tdClass: "table-col-dinamic-width",
        },
      ],
      isBusy: false,
      model: [],
      newModel: [
        {
          formId: 0,
          powerBiViewId: 0,
          sequenceNumber: 0,
          moduleId: this.id,
          formName: "",
          biName: "",
        },
      ],
      type: 0,
      modelstate: [],
      tableFilters: [],
      tableRows: [],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      biOptions: [],
      formOptions: [],
    };
  },
  computed: {
    getUrlBackToList() {
      return `../../module/all`;
    },
    fieldsList() {
      let fields = [];
      for (let campo of this.tableRows.sort(
        (c1, c2) => c1.item.sequenciaExibicao - c2.item.sequenciaExibicao
      )) {
        if (campo.item.active) {
          fields.push(campo);
        }
      }
      return fields;
    },
  },
  created() {
    this.myProvider();
    this.getModuleType();
  },
  methods: {
    addTableRow(item) {
      this.tableRows.push({
        detailsShowing: false,
        item: item,
      });
    },
    addFields(newModel) {
      let item = {
        formId: newModel.formId,
        powerBiViewId: newModel.powerBiViewId,
        sequenceNumber: this.getNextSequenceNumber(this.model),
        moduleId: parseInt(this.id),
        active: true,
        formName: newModel.formName,
        biName: newModel.biName,
      };
      this.model.push(item);
      this.addTableRow(item);
      this.$forceUpdate();
    },
    deleteField(row) {
      // console.log(row);
      if (!row.item.id || row.item.id == 0) {
        let rowIndex = this.tableRows.indexOf(row);
        if (rowIndex >= 0) {
          this.tableRows.splice(rowIndex, 1);
        }
        let itemIndex = this.model.indexOf(row.item);
        if (itemIndex >= 0) {
          this.model.splice(itemIndex, 1);
        }
      } else {
        row.item.active = false;
      }
      let campos = this.fieldsList;
      // console.log(campos);
      for (let i = 0; i < campos.length; i++) {
        campos[i].item.sequenceNumber = i + 1;
      }
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.model) {
        if (this.model.length > 0) {
          this.model.forEach((item) => {
            this.addTableRow(item);
          });
        }
      }
      this.$forceUpdate();
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      this.$apiScheduler
        .post("/moduleMenu/all/" + this.id)
        .then((response) => {
          const items = response.data;
          this.model = response.data;
          this.getModelDropdown();
          this.isBusy = false;
          items.forEach((item) => {
            this.addTableRow(item);
          });
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    save() {
      this.submitted = true;
      this.$apiScheduler
        .post("/moduleMenu/save/" + parseInt(this.id), this.model)
        .then((response) => {
          this.model = response.data;
          this.$forceUpdate();
          this.modelstate = {};
          this.submitted = false;
          this.alert.success = "Registro salvo com sucesso";
          this.$refs.alert.show();
        })

        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error =
                error.response.status + " - " + error.response.statusText;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error =
                error.response.status + " - " + error.response.statusText;
              this.$refs.danger.show();
            } else {
              this.alert.error =
                error.response.status + " - " + error.response.statusText;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error =
              error.response.status + " - " + error.response.statusText;
            this.$refs.danger.show();
          }
        });
    },
    getModuleType() {
      this.$apiScheduler
        .get("/module/get/" + this.id)
        .then((response) => {
          // console.log(response);
          this.type = response.data.type;
          // console.log(this.type);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
    },
    getModelDropdown() {
      let dropdown = [];
      let formDropdown = [];
      this.model.forEach((item) => {
        if (item.powerBiViewId != null) {
          dropdown.push({
            value: item.powerBiViewId,
            text: item.biName,
          });
        }
        if (item.formId != null) {
          formDropdown.push({
            value: item.formId,
            text: item.formName,
          });
        }
      });
      this.biOptions = dropdown;
      this.formOptions = formDropdown;
    },
  },
  watch: {
    newModel() {
      this.addFields(this.newModel);
    },
    model() {
      this.loadTableRows();
      this.getModelDropdown();
    },
  },
};
</script>
<style scoped>
.biModal {
  margin-left: -12% !important;
}
</style>